import { Buffer } from 'buffer';

// Добавляем Buffer в глобальную область видимости
window.Buffer = Buffer;

// Также добавляем process если нужно
window.process = require('process/browser');